var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiAgents = function SvgAiAgents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-agents_svg__a)",
    fillRule: "evenodd",
    d: "M7 56C7 28.938 28.938 7 56 7s49 21.938 49 49c0 13.71-5.631 26.106-14.707 35H91a7 7 0 1 1 0 14H21a7 7 0 1 1 0-14h.707C12.631 82.106 7 69.71 7 56m64.75 0a5.25 5.25 0 0 1-5.25-5.25V45.5h-5.25a5.25 5.25 0 0 1 0-10.5h5.25v-5.25a5.25 5.25 0 0 1 10.5 0V35h5.25a5.25 5.25 0 0 1 0 10.5H77v5.25c0 2.9-2.35 5.25-5.25 5.25M42 63a7 7 0 1 0 14 0 7 7 0 0 0-14 0",
    clipRule: "evenodd",
    opacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-agents_svg__a",
    x1: 80.5,
    x2: 55.192,
    y1: 7,
    y2: 104.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66B3FF"
  })))));
};
export { SvgAiAgents as ReactComponent };